<template>
  <div class="screen page formActions b-soft">
    <div id="pantalla-espera" v-if="isLoading"></div>
    <div class="grid">
      <form v-on:submit.prevent="actionForm(id, producto, 'productos', 'form')" class="form layout">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <label for="color">Selecciona un Color</label>
              <swatches v-model="producto.color" :colors="colors" row-length="20" popover-to="right" swatch-size="20"></swatches>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto.nombre != ''}">
              <label for="nombre">Nombre</label>
              <input id="nombre" type="text" v-model="producto.nombre" placeholder="Escribe algo...">
            </div>
            <div class="col-12" v-bind:class="{'filled': producto.id_servicio}">
              <label>Servicio</label>
              <multiselect 
              v-model="producto.id_servicio" 
              :options="servicios" 
              :multiple="false" 
              :show-labels="false" 
              :close-on-select="true" 
              :hide-selected="false" 
              :preserve-search="false" 
              :searchable="true" 
              placeholder="Selecciona un servicio" 
              label="nombre" 
              track-by="id" 
              :allow-empty="true" 
              :preselect-first="false">
              <span slot="noResult">No se encontraron resultados.</span>
              </multiselect>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto.contenido != ''}">
              <label for="contenido">Contenido</label>
              <ckeditor :editor="editor" v-model="producto.contenido" :config="editorConfigContent"></ckeditor>
            </div>
            <div class="col-12" v-bind:class="{'filled': producto.anotaciones != ''}">
              <label for="anotaciones">Anotaciones</label>
              <ckeditor :editor="editor" v-model="producto.anotaciones" :config="editorConfigText"></ckeditor>
            </div>
            <div class="col-4" v-bind:class="{'filled': producto.precio_1 != ''}">
              <label for="precio_1">Precio 1</label>
              <input id="precio_1" type="text" v-model="producto.precio_1" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
            </div>
            <div class="col-4" v-bind:class="{'filled': producto.precio_2 != ''}">
              <label for="precio_2">Precio 2</label>
              <input id="precio_2" type="text" v-model="producto.precio_2" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
            </div>
            <div class="col-4" v-bind:class="{'filled': producto.precio_3 != ''}">
              <label for="precio_3">Precio 3</label>
              <input id="precio_3" type="text" v-model="producto.precio_3" placeholder="Escribe algo..." v-on:focus="$event.target.select()">
            </div>
            <div class="col-12">
              <ul v-if="messages.length" class="messages-container">
                <li v-for="message in messages" :key="message.content" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message)"></i> {{message.content}}</li>
              </ul>
            </div>
            <div class="col-12">
              <button v-if="id" type="submit" class="btn b-secondary">Guardar Cambios</button>
              <button v-if="id" v-on:click.prevent="actionForm(id, producto, 'productos', 'clone')" class="btn b-primary">Clonar Elemento</button>
              <button v-else type="submit" class="btn b-secondary">Crear Nuevo Elemento</button>
            </div>
          </div>
        </div>
      </form>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import Swatches from 'vue-swatches'
import Multiselect from 'vue-multiselect'
import router from '@/router'
import { getColors } from '@/colors.js'
import { db, auth } from '@/firebase'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/es'
export default {
  name: 'app',
  components: {
    GetFooter,
    Multiselect,
    Swatches
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfigContent: {
        fontSize: {
          options: [
            10,
            'default',
            14,
            16,
            18,
            21,
            24
          ]
        },
        toolbar: {
          items: [
            //'heading',
            'fontSize', 
            '|',
            'bold',
            //'italic',
            //'link',
            'bulletedList',
            //'numberedList',
            //'imageUpload',
            //'blockQuote',
            'undo',
            'redo'
          ]
        },
        language: 'es'
      },
      editorConfigText: {
        fontSize: {
          options: [
            10,
            'default',
            14,
            16,
            18,
            21,
            24
          ]
        },
        toolbar: {
          items: [
            //'heading',
            'fontSize', 
            '|',
            'bold',
            //'italic',
            //'link',
            //'bulletedList',
            //'numberedList',
            //'imageUpload',
            //'blockQuote',
            'undo',
            'redo'
          ]
        },
        language: 'es'
      },
      isLoading: false,
      isEditing: false, 
      id: this.$route.params.id,
      servicios: [],
      producto: [],
      inicio_producto: [],
      usuario_login: [],
      messages: [],
      colors: getColors
    }
  },
  firestore () {
    return {
      usuario_login: db.collection('usuarios').doc(auth.currentUser.uid),
      servicios: db.collection('servicios').orderBy('orden', 'asc')
    }
  },
  created() {
    if(this.$route.params.id){
      this.$bind('inicio_producto', db.collection('productos').doc(this.id)).then(inicio_producto => {
        this.inicio_producto === 'inicio_producto'
        this.$unbind('inicio_producto', false)
      })
      this.$bind('producto', db.collection('productos').doc(this.id)).then(producto => {
        this.producto === 'producto'
        this.$unbind('producto', false)
      })
    }
  },
  watch: {
    producto: {
      handler(newArray){
        if(!Array.isArray(newArray)){
          //Los campos con formato html nunca coinciden por el tamaño por default de 12px que se pone en un span y se quita al momento de colocar en el editor se puede usar newArray.contenido.replace(/<[^>]*>?/gm, '') para obtener todo el texto pero no es lo mejor
          if((this.inicio_producto.nombre != newArray.nombre) || (this.inicio_producto.id_servicio.id != newArray.id_servicio.id)){
            this.isEditing = true
          }else{
            this.isEditing = false
          }
        }else{
          this.isEditing = false
        }
        if(newArray.precio_1){
          newArray.precio_1 = this.$options.filters.formatNumber(newArray.precio_1)
        }
        if(newArray.precio_2){
          newArray.precio_2 = this.$options.filters.formatNumber(newArray.precio_2)
        }
        if(newArray.precio_3){
          newArray.precio_3 = this.$options.filters.formatNumber(newArray.precio_3)
        }
      },
      deep: true,
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isEditing === true){
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      } else {
        next(false)
      }
    }else{
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  methods: {
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
    },
    delete_message (value){
     this.messages.splice(this.messages.indexOf(value), 1)
    },
    actionForm (id, elemento, collection, type) {
      const id_producto = id
      var item_nombre = elemento.nombre
      var item_color = elemento.color
      var item_id_servicio = elemento.id_servicio
      var item_creacion = new Date()
      var url = 'dashboard'

      this.messages = []

      if(!item_nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un nombre'
        }
        this.messages.push(the_message)
      }

      if(!item_color) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un color'
        }
        this.messages.push(the_message)
      }

      if(!item_id_servicio) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un servicio'
        }
        this.messages.push(the_message)
      }

      if(!elemento.contenido){
        elemento.contenido = '';
      }

      if(!elemento.anotaciones){
        elemento.anotaciones = '';
      }

      if(!elemento.precio_1){
        elemento.precio_1 = '';
      }

      if(!elemento.precio_2){
        elemento.precio_2 = '';
      }

      if(!elemento.precio_3){
        elemento.precio_3 = '';
      }

      if(!this.messages.length) {
        this.isLoading = true
        this.isEditing = false
        var vm = this
        //Verificar tipo de accion
        if(type === 'clone'){
          //Clonar elemento
          if(window.confirm('¿Estás Seguro? Si no haz guardado los cambios estos se aplicarán solamente al elemento clonado.')){
            db.collection(collection).add({
              color: elemento.color,
              fecha_creacion: item_creacion,
              fecha_modificacion: item_creacion,
              nombre: elemento.nombre, 
              contenido: elemento.contenido,
              anotaciones: elemento.anotaciones, 
              precio_1: elemento.precio_1, 
              precio_2: elemento.precio_2, 
              precio_3: elemento.precio_3, 
              id_servicio: db.collection('servicios').doc(elemento.id_servicio.id), 
              usuario_creador: vm.usuario_login.nombre, 
              usuario_editor: vm.usuario_login.nombre
            })
            .then(function(doc) {
              //Documento creado con exito
              vm.isLoading = false
              router.push('/productos/', () => {})
            })
            .catch(function(error) {
              //Error al crear
              vm.isLoading = false
              vm.messages.push({type: 'fatal b-fail', content: error.message})
            })
          }
        }else if(id_producto && type === 'form'){
          //Actualizar elemento
          db.collection(collection).doc(id_producto).update({
            color: elemento.color,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            contenido: elemento.contenido, 
            anotaciones: elemento.anotaciones, 
            precio_1: elemento.precio_1, 
            precio_2: elemento.precio_2, 
            precio_3: elemento.precio_3, 
            id_servicio: db.collection('servicios').doc(elemento.id_servicio.id), 
            usuario_editor: vm.usuario_login.nombre
          })
          .then(function(doc) {
            //Se actualizo con exito el documento
            setTimeout(function(){
              vm.isLoading = false
            }, 1200)
            vm.messages.push({type: 'success b-secondary', content: 'Se han guardado los cambios'})
          })
          .catch(function(error) {
            //Error al actualizar
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }else if(!id_producto && type === 'form'){
          //Crear elemento
          db.collection(collection).add({
            color: elemento.color,
            fecha_creacion: item_creacion,
            fecha_modificacion: item_creacion,
            nombre: elemento.nombre, 
            contenido: elemento.contenido, 
            anotaciones: elemento.anotaciones, 
            precio_1: elemento.precio_1, 
            precio_2: elemento.precio_2, 
            precio_3: elemento.precio_3, 
            id_servicio: db.collection('servicios').doc(elemento.id_servicio.id), 
            usuario_creador: vm.usuario_login.nombre, 
            usuario_editor: vm.usuario_login.nombre
          })
          .then(function(doc) {
            //Documento creado con exito
            vm.isLoading = false
            router.push('/productos/', () => {})
          })
          .catch(function(error) {
            //Error al crear
            vm.isLoading = false
            vm.messages.push({type: 'fatal b-fail', content: error.message})
          })
        }
      }
    }
  },
}
</script>
<style src='vue-swatches/dist/vue-swatches.min.css'></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>